// extracted by mini-css-extract-plugin
module.exports = {"modal":"live-conversations__ConversationList__modal"};